import { CasinoBalance } from '@/unified-modules/wallet/helpers/normalize-balance';
import { walletBalance } from '@/unified-modules/wallet/helpers/wallet-balance';

const DEFAULT_MAX_ATTEMPTS = 2;
const RETRY_DELAY_MS = 500;

const delay = (ms: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/** Revalidates wallet data for My Account; retries transient empty/failed UM reads. */
export const walletBalanceWithRetry = async (
  maxAttempts = DEFAULT_MAX_ATTEMPTS,
): Promise<CasinoBalance> => {
  let lastError: unknown;

  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    try {
      return await walletBalance();
    } catch (error) {
      lastError = error;
      if (attempt < maxAttempts - 1) {
        await delay(RETRY_DELAY_MS * (attempt + 1));
      }
    }
  }

  throw lastError;
};
